// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "span.w-item-summary--text{white-space:pre-wrap;word-break:break-word;text-overflow:unset;overflow:hidden}span.w-item-summary--more{padding-top:3px;font-size:13px;font-weight:500}span>span>*{display:none}", ""]);
// Exports
module.exports = exports;
